export const ISSUE_STATE_CLOSED = 100;
export const ISSUE_STATE_RESOLVED = 200;
export const ISSUE_STATE_OPENED = 300;

export const prepareLocation = (location, isNew=false) => {
    let renderString = '';

    if(!location) return renderString;

    if(location.projectSettings.main.key === 'residential' && location.projectSettings.sub.key === 'single-family' || location.projectSettings.main.key === 'commercial' && location.projectSettings.sub.key === 'single-unit'){
        renderString = '';
    }
    if(location.projectSettings.main.key === 'residential' && location.projectSettings.sub.key === 'multiple-houses' || location.projectSettings.main.key === 'commercial' && location.projectSettings.sub.key === 'public-area'){
        renderString = `${location.unit.name}. `;
    }
    if(location.projectSettings.main.key === 'residential' && location.projectSettings.sub.key === 'building-complex' || location.projectSettings.main.key === 'commercial' && location.projectSettings.sub.key === 'building-complex' || location.projectSettings.main.key === 'general' && location.projectSettings.sub.key === 'general'){
        if(isNew) renderString = location.building && location.building.name ? `${location.building.name}, ` : '';
        renderString += location.floor && location.floor.name ? `${location.floor.name}` : '';
        renderString += location.unit && location.unit.name ? `, ${location.unit.name}.` : '';
    }

    let roomArray = [];
    let roomString = '';

    if(location.room) {
        Object.values(location.room).map((room) => {
            roomArray.push(room.name);
        });
        roomString = roomArray.join(', ');
    }

    return renderString + roomString;
};

export const getIssueStatus = (status) => {
    const statusObj = {
        [ISSUE_STATE_OPENED]: 'Open',
        [ISSUE_STATE_RESOLVED]: 'Resolve',
        [ISSUE_STATE_CLOSED]: 'Close'
    };

    return statusObj[status]
};
